import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.esm.js';

function isRelativeHref(href) {
  var pathname = typeof href === 'object' ? href.pathname : href;
  return pathname != null && !pathname.startsWith('/');
}
function isLocalHref(href) {
  if (typeof href === 'object') {
    return href.host == null && href.hostname == null;
  } else {
    var hasProtocol = /^[a-z]+:/i.test(href);
    return !hasProtocol;
  }
}
function localizeHref(href, locale, defaultLocale, pathname) {
  if (defaultLocale === void 0) {
    defaultLocale = locale;
  }
  if (!isLocalHref(href) || isRelativeHref(href)) {
    return href;
  }
  var isSwitchingLocale = locale !== defaultLocale;
  var isPathnamePrefixed = locale == null || hasPathnamePrefixed(locale, pathname);
  var shouldPrefix = isPathnamePrefixed || isSwitchingLocale;
  if (shouldPrefix && locale != null) {
    return prefixHref(href, locale);
  }
  return href;
}
function prefixHref(href, locale) {
  var prefixedHref;
  if (typeof href === 'string') {
    prefixedHref = localizePathname(locale, href);
  } else {
    prefixedHref = _extends({}, href);
    if (href.pathname) {
      prefixedHref.pathname = localizePathname(locale, href.pathname);
    }
  }
  return prefixedHref;
}
function unlocalizePathname(pathname, locale) {
  return pathname.replace(new RegExp("^/" + locale), '') || '/';
}
function localizePathname(locale, pathname) {
  var localizedHref = '/' + locale;
  // Avoid trailing slashes
  if (/^\/(\?.*)?$/.test(pathname)) {
    pathname = pathname.slice(1);
  }
  localizedHref += pathname;
  return localizedHref;
}
function hasPathnamePrefixed(locale, pathname) {
  var prefix = "/" + locale;
  return pathname === prefix || pathname.startsWith(prefix + "/");
}
function matchesPathname( /** E.g. `/users/[userId]-[userName]` */
template, /** E.g. `/users/23-jane` */
pathname) {
  var regex = templateToRegex(template);
  return regex.test(pathname);
}
function templateToRegex(template) {
  var regexPattern = template.replace(/\[([^\]]+)\]/g, function (match) {
    if (match.startsWith('[...')) return '(.*)';
    if (match.startsWith('[[...')) return '(.*)';
    return '([^/]+)';
  })
  // Clean up regex match remainders from optional catchall ('[[...slug]]')
  .replaceAll('(.*)]', '(.*)');
  return new RegExp("^" + regexPattern + "$");
}

export { hasPathnamePrefixed, isLocalHref, isRelativeHref, localizeHref, localizePathname, matchesPathname, prefixHref, templateToRegex, unlocalizePathname };
//# sourceMappingURL=utils.esm.js.map
